module.exports = "/img/calculator-banner-3.6d60666f.png";